// Simple shared utility to count non-empty filter fields (string/number) plus optional array-based date range
export function countActiveFilters(obj, keys = [], options = {}) {
  if (!obj) return 0;
  const { dateKey } = options; // dateKey: name of date array property to count if both ends present
  let count = 0;
  keys.forEach(k => {
    const v = obj[k];
    if (v !== undefined && v !== null && v !== '') count++;
  });
  if (dateKey && Array.isArray(obj[dateKey]) && obj[dateKey][0] && obj[dateKey][1]) {
    count++;
  }
  return count;
}
